import {APIChannelService} from "../../config/axios-channel-service";
import _ from "lodash";
import {Option} from "modules/UAA/configs/constant";

const api = new APIChannelService();

export const CancelChannel = {
  filter(payload) {
    Object.keys(payload).forEach((key) => {
      if (payload[key] === Option.ALL) {
        // payload[key] = null;
        delete payload[key];
      }
    });
    const requestBody = _.cloneDeep(payload);
    delete requestBody.page;
    delete requestBody.size;
    return api.postFilter(
      `/api/v1/channel/register/search?page=${payload.page}&size=${payload.size}`,
      requestBody
    );
  },
  approve({ id }) {
    return api.put(`/api/v1/channel/cancel-channel/${id}/approve`);
  },
  reject({ id, reason: content }) {
    return api.put(`/api/v1/channel/cancel-channel/${id}/reject`, {
      content,
    });
  },
  infoCancel(payload) {
    Object.keys(payload).forEach((key) => {
      if (payload[key] === Option.ALL) {
        delete payload[key];
      }
    });

    const temp = _.omit(
      {
        ...payload,
        phoneNumber: payload.phoneNumberSearch,
        channelTypeId: payload.channelTypeIdSearch ?? "",
      },
      ["phoneNumberSearch", "channelTypeIdSearch"]
    );

    return api.get(`/api/v1/channel/info-cancel`, temp);
  },
  historyInfo(payload) {
    Object.keys(payload).forEach((key) => {
      if (payload[key] === Option.ALL) {
        payload[key] = null;
      }
    });
    let requestBody = _.cloneDeep(payload);

    delete requestBody.page;
    delete requestBody.size;
    return api.post(
      `/api/v1/channel/history-cancel?page=${payload.page}&size=${payload.size}`,
      payload
    );
  },
  requestCancel(payload) {
    const requestBody = _.cloneDeep(payload);
    delete requestBody.channelId;

    return api.put(
      `/api/v1/channel-temp/request-cancel-channel/${payload.channelId}`,
      requestBody
    );
  },
};
